enum ContentManagementActions {
  FETCH_LIST = "ContentManagementFetchList",
  SEARCH_LIST = "ContentManagementSearchList",
  GET_REFERENCE_SETTINGS = "ContentManagementGetReferenceSettings",
  GET_REFERENCE_TOPICS = "ContentManagementGetReferenceTopics",
  GET_REFERENCE_OPTIONS = "ContentManagementGetReferenceOptions",
  GET_SERVICE_OPTIONS = "ContentManagementGetServiceOptions",
  GET_ADDRESSBOOK_OPTIONS = "ContentManagementGetAddressbookOptions",
  GET_PRODUCT_OPTIONS = "ContentManagementGetProductOptions",
  GET_CATEGORY_OPTIONS = "ContentManagementGetCategoryOptions",
  GET_ITEM = "ContentManagementGetItem",
  CREATE_ITEM = "ContentManagementCreateItem",
  UPDATE_ITEM = "ContentManagementUpdateItem",
  UPDATE_META = "ContentManagementUpdateMeta",
  UPDATE_REFERENCE = "ContentManagementUpdateReference",
  UPDATE_BLOCKS = "ContentManagementUpdateBlocks",
  UPDATE_ATTRIBUTES = "ContentManagementUpdateAttributes",
  DELETE_ITEM = "ContentManagementDeleteItem",
  REFRESH_LIST = "ContentManagementRefreshList",

  FETCH_BLOCKS = "ContentManagementFetchBlocks",
  GET_BLOCK = "ContentManagementGetBlock",
  GET_BLOCK_PREVIEW = "ContentManagementGetBlockPreview",
  CREATE_BLOCK = "ContentManagementCreateBlock",
  UPDATE_BLOCK = "ContentManagementUpdateBlock",
  UPDATE_BLOCK_TRANSLATIONS = "ContentManagementUpdateBlockTranslations",
  UPDATE_BLOCK_ATTRIBUTES = "ContentManagementUpdateBlockAttributes",
  DELETE_BLOCK = "ContentManagementDeleteBlocks",
  REFRESH_BLOCKS = "ContentManagementRefreshBlocks",

  GET_NAVIGATION_OPTIONS = "ContentManagementGetNavigationOptions",
  GET_BLOCK_TYPES = "ContentManagementGetBlockTypes",

  FETCH_PENDING_BLOCKS = "ContentManagementFetchPendingBlocks",
  PUBLISH_BLOCKS = "ContentManagementPublishBlocks",

  FETCH_PUBLISH_LOG = "ContentManagementFetchPublishLog",
  CLEAR_CACHE = "ContentManagementClearCache",

  FETCH_PROMOTIONS = "ContentManagementFetchPromotions",
  GET_PROMOTION = "ContentManagementGetPromotion",
  CREATE_PROMOTION = "ContentManagementCreatePromotion",
  UPDATE_PROMOTION = "ContentManagementUpdatePromotion",
  UPDATE_PROMOTION_TRANSLATION = "ContentManagementUpdatePromotionTranslation",
  DELETE_PROMOTION = "ContentManagementDeletePromotion",
  GET_PROMOTION_OPTIONS = "ContentManagementGetPromotionOptions",
  REFRESH_PROMOTIONS = "ContentManagementRefreshPromotions",
}

enum ContentManagementMutation {
  SET_RENDER_UPDATE = "ContentManagementListRenderNeeded",
  SET_LIST_RESULT = "ContentManagementListResult",
  SET_BLOCKS_RESULT = "ContentManagementListResultBlocks",
  SET_NAVIGATION_OPTIONS = "ContentManagementSetNavigationOptions",
  SET_BLOCK_TYPES = "ContentManagementSetBlockTypes",
  SET_PENDING_BLOCKS_RESULT = "ContentManagementPendingBlocksResult",
  SET_PUBLISH_LOG_RESULT = "ContentManagementPublishLogResult",
  SET_PROMOTIONS_RESULT = "ContentManagementPromotionsResult",
  SET_PROMOTION_OPTIONS = "ContentManagementSetPromotionOptions",
}

export { ContentManagementActions, ContentManagementMutation };
